import React, { useReducer } from 'react';
import './Lightbox.css';

import {
  apiLogIn,
  apiSignIn,
  signInReducer,
  loginState,
  signinState,
  handleSignIn,
} from './utils';

const Field = (type, placeholder, field, dispatch) => (
  <input
    className="login_field"
    type={type}
    placeholder={placeholder}
    name={field}
    onChange={(e) => dispatch({
      type: 'field',
      field,
      value: e.target.value,
    })}
  />
);

const UserField = (dispatch) => Field('text', 'Username', 'username', dispatch);
const PasswordField = (dispatch) => Field('password', 'Password', 'password', dispatch);
const PasswordRepeatField = (dispatch) => Field('password', 'Repeat password', 'passwordRepeat', dispatch);

const Form = (
  iniState,
  margin,
  text,
  apiFunc,
  login,
  ExtraField,
) => {
  const [state, dispatch] = useReducer(signInReducer, iniState);
  const {
    username,
    password,
    error,
    passwordRepeat,
  } = state;
  const args = [username, password, passwordRepeat];
  return (
    <div className="login_box" style={margin}>
      <p className="form_top">{text}</p>
      <div className="line" />
      <form className="form" onSubmit={(e) => handleSignIn(e, dispatch, apiFunc, login, ...args)}>
        {UserField(dispatch)}
        {PasswordField(dispatch)}
        {ExtraField && ExtraField(dispatch)}
        <button type="submit" className="box_button">{text}</button>
      </form>
      {error}
    </div>
  );
};

const Login = (login) => Form(loginState, { marginLeft: 10 }, 'Log in', apiLogIn, login);
const SignUp = (login) => Form(signinState, { marginRight: 10 }, 'Sign In', apiSignIn, login, PasswordRepeatField);

export default ({ login }) => (
  <>
    {SignUp(login)}
    {Login(login)}
  </>
);
